import { api } from "../api";

type VehicleTransferType = {
    customerId: number;
    secretaryId: number;
    currentDepartmentId: number;
    targetDepartmentId: number;
    vehicles: Array<string>;
    isSharing: boolean;
};

/**
 * updateVehicleDepartmentById - Function that updates the department of an existing vehicle by id  
 * /vehicles/departments
 * method PUT  
 * @async-function
 */
const updateVehicleDepartmentById = async (token: string, model: VehicleTransferType) => {
    const response = await api.put(
        `/vehicles/departments`, { ...model }, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response;
};

export default updateVehicleDepartmentById;
